import { createContext, useContext } from 'react';

export const SchoolIdContext = createContext<string | undefined>(undefined);

export const useSchoolIdContext = () => {
  const schoolId = useContext(SchoolIdContext);
  return schoolId ?? '';
};
